import { render } from "./BatchIntakeManager.vue?vue&type=template&id=dc16bafa&scoped=true"
import script from "./BatchIntakeManager.vue?vue&type=script&lang=js"
export * from "./BatchIntakeManager.vue?vue&type=script&lang=js"

import "./BatchIntakeManager.vue?vue&type=style&index=0&id=dc16bafa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dc16bafa"]])

export default __exports__